import ValidService from "../../../../service/ValidService"

export default {
  dataForm: {
    "name": undefined, // required - Tên văn bản
    "template_config_id": undefined, // optional - Phân loại mẫu cấu hình
    "code": undefined, // required, maxLength: 50 - Ký hiệu
    "type": undefined, // optional, enum(EXTERNAL_DOC_IN, EXTERNAL_DOC_OUT, INTERNAL_DOC) - Loại văn bản ĐẾN/ĐI
    "description": undefined, // optional - Trích yếu
    "company_id": undefined, // optional, ref: company - Mã công ty
    "document_category_id": undefined, // optional, ref: document_category - Loại văn bản
    "document_category_name": undefined, // optional - Tên văn bản
    "business_id": undefined, // required, ref: business - Ngành kinh doanh
    "doc_file": // optional - File văn bản
    {
      "doc_id": undefined, // required, ref: mushroom_file - File văn bản
      "doc_name": undefined, // optional - Tên file
      "capacity": undefined, // optional - Dung lượng (MB)
      "type": undefined, // optional - Loại file pdf, doc..
    },
    "disabled": undefined, // required - Đã bị khóa chưa
  },
  validForm: {
    'name': [ValidService.required],
    'doc_file': {
      "doc_id": [ValidService.requiredChange]
    }
  },
  tableRules: {
    data: [],
    lengthMenu: [20, 40, 80, 120, 200, 500],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 20,
    offset: 0,
    sort: "-created_at",
    defaultSort: ['created_at', 'descending'],
    filters: "",
    recordSelected: [],
    dataSearch: {
      value: {
        "name_code": '',
        "created_at": '',
      },
      valid: {},
      operator: {
        "name_code": '$vn_text=',
        "created_at": ':in_that_day:',
      }
    },
  }
}
